exports = module.exports = require("../node_modules/_css-loader@0.27.3@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#app,body,html{height:100%;width:100%;margin:0;padding:0}*,:after,:before{box-sizing:border-box}h1,h2,h3,h4,h5,h6,p{margin:0;padding:0}img{vertical-align:top}a{color:#07a}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.27.3@css-loader?minimize!./~/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7537c995","scoped":false,"hasInlineConfig":false}!./~/_less-loader@5.0.0@less-loader/dist/cjs.js!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 323
// module chunks = 0